import React from 'react';

import { Stack, StackProps } from '_lib/components/Stack/Stack';
import { Typography, TypographyProps } from '_lib/components/Typography/Typography';

export const IconTypography = (props: TypographyProps & { startIcon: React.JSX.Element; stackProps?: StackProps }) => {
  const { startIcon, stackProps, ...typographyProps } = props;

  return (
    <Stack useFlexGap direction='row' spacing={0.5} alignItems='center' {...stackProps}>
      {startIcon}
      <Typography {...typographyProps} />
    </Stack>
  );
};
